import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { laArtPrinRepaySchedRptTypeClassConfig } from './LaArtPrinRepaySchedRptType.name';

/** リース物件元本返済予定表の帳票種類ENUM */
enum LaArtPrinRepaySchedRptType {
  /**リース物件元本返済予定表(集計表) */
  principalRepaymentScheduleSummary = '1',
  /**リース物件元本返済予定表(明細表) */
  principalRepaymentScheduleStatement = '2',
}

const laArtPrinRepaySchedRptTypeMap = new Map([
  ['1', LaArtPrinRepaySchedRptType.principalRepaymentScheduleSummary],
  ['2', LaArtPrinRepaySchedRptType.principalRepaymentScheduleStatement],
]);

const rawValueToLaArtPrinRepaySchedRptType = rawValueToEnumWithDefault(
  laArtPrinRepaySchedRptTypeMap,
  LaArtPrinRepaySchedRptType.principalRepaymentScheduleSummary,
);

const laArtPrinRepaySchedRptTypeToDisplay = enumToNameWithDefault(
  LaArtPrinRepaySchedRptType,
  laArtPrinRepaySchedRptTypeClassConfig,
);

const laArtPrinRepaySchedRptTypeToDisplayWithPrefix = enumToNameWithDefault(
  LaArtPrinRepaySchedRptType,
  laArtPrinRepaySchedRptTypeClassConfig,
  true,
);

export {
  LaArtPrinRepaySchedRptType,
  laArtPrinRepaySchedRptTypeToDisplay,
  laArtPrinRepaySchedRptTypeToDisplayWithPrefix,
  rawValueToLaArtPrinRepaySchedRptType,
};
